/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BusinessType {
  CORPORATION = 'corporation',
  LIMITED_LIABILITY_COMPANY = 'limited_liability_company',
  LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership',
  LIMITED_PARTNERSHIP = 'limited_partnership',
  GENERAL_PARTNERSHIP = 'general_partnership',
  SOLE_PROPRIETOR = 'sole_proprietor',
  OTHER = 'other',
}
